import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import TextField from '@mui/material/TextField';
import OpeningHours from '../../../../MySections/TimeSections/OpeningHours';
import { Accordion, Card } from 'react-bootstrap';
import { RestContext } from '../../../../MyContexts/Rest_Context';


const TabOrdersOprtions = (props) => {

    const [rest] = useContext(RestContext);

    const [buisReservation, setBuisReservation] = useState(rest.buisReservation);
    const [takeAway, setTakeAway] = useState(rest.TakeAway);
    const [delivery, setDelivery] = useState(rest.Delivery);
    const [deliveryHours, setDeliveryHours] = useState(rest.DeliveryHours);

    useEffect(() => {
    }, [])

    return (
        <>
            <Accordion defaultActiveKey="0" className="has-gap ms-accordion-chevron ordersOpts">
                <Card>
                    <Accordion.Collapse className="collapseparent" eventKey="0">
                        <Card.Body>
                            <div className={"col-md-12 mb-2 tblHours fullRow"}>
                                <div className={"input-group switchMe onRight"}>
                                    <label className="ms-switch">
                                        <input type="checkbox" id={"validationCustom5_1"} checked={buisReservation}
                                            onChange={() => { rest["buisReservation"] = !buisReservation; setBuisReservation(!buisReservation) }} />
                                        <span className="ms-switch-slider ms-switch-primary round" />
                                    </label> <span className={"spHead onRight"}>הזמנת מקום</span>
                                </div>
                            </div>
                            <div className={"col-md-12 mb-2 tblHours fullRow"}>
                                <div className={"input-group switchMe onRight"}>
                                    <label className="ms-switch">
                                        <input type="checkbox" id={"validationCustom5_31"} checked={takeAway.Doing}
                                            onChange={() => {
                                                rest["TakeAway"] = { Doing: !takeAway.Doing, Time: takeAway.Time };
                                                setTakeAway({ Doing: !takeAway.Doing, Time: takeAway.Time })

                                            }} />
                                        <span className="ms-switch-slider ms-switch-primary round" />
                                    </label> <span className={"spHead"}>איסוף</span>
                                </div>
                                <div className={"onRight"}>
                                    {takeAway.Doing ?
                                        <TextField className={"onRight txtField"} id="validationCustom5_32" size="small" label="זמן הכנה (דק')" value={takeAway.Time}
                                            onChange={(e) => {
                                                rest["TakeAway"] = { Doing: takeAway.Doing, Time: e.target.value };
                                                setTakeAway({ Doing: takeAway.Doing, Time: e.target.value })
                                            }} />
                                        : ""}
                                </div>


                            </div>
                            <div className={"col-md-12 mb-2 tblHours fullRow"}>
                                <div className={"input-group switchMe onRight"}>
                                    <label className="ms-switch">
                                        <input type="checkbox" id={"validationCustom5_3"} checked={delivery.Doing}
                                            onChange={() => {
                                                rest["Delivery"] = { Doing: !delivery.Doing, Time: delivery.Time, Price: delivery.Price, MiniDelPrice: delivery.MiniDelPrice };
                                                setDelivery({ Doing: !delivery.Doing, Time: delivery.Time, Price: delivery.Price, MiniDelPrice: delivery.MiniDelPrice })
                                            }} />
                                        <span className="ms-switch-slider ms-switch-primary round" />
                                    </label> <span className={"spHead"}>משלוחים</span>
                                </div>
                                <div className={"onRight"}>
                                    {delivery.Doing ?
                                        <>
                                            <TextField className={"onRight txtField"} id="validationCustom5_33" size="small" label="זמן הכנה (דק')" value={delivery.Time}
                                                onChange={(e) => {
                                                    rest["Delivery"] = { Doing: delivery.Doing, Time: e.target.value, Price: delivery.Price, MiniDelPrice: delivery.MiniDelPrice };
                                                    setDelivery({ Doing: delivery.Doing, Time: e.target.value, Price: delivery.Price, MiniDelPrice: delivery.MiniDelPrice })
                                                }} />
                                            <TextField className={"onRight txtField"} id="validationCustom5_33" size="small" label="דמי משלוח (₪)" value={delivery.Price}
                                                onChange={(e) => {
                                                    rest["Delivery"] = { Doing: delivery.Doing, Time: delivery.Time, Price: e.target.value, MiniDelPrice: delivery.MiniDelPrice };
                                                    setDelivery({ Doing: delivery.Doing, Time: delivery.Time, Price: e.target.value, MiniDelPrice: delivery.MiniDelPrice })
                                                }} />
                                            <TextField className={"onRight txtField"} id="validationCustom5_33" size="small" label="מינימום מחיר הזמנה(₪)" value={delivery.MiniDelPrice}
                                                onChange={(e) => {
                                                    rest["Delivery"] = { Doing: delivery.Doing, Time: delivery.Time, Price: delivery.Price, MiniDelPrice: e.target.value };
                                                    setDelivery({ Doing: delivery.Doing, Time: delivery.Time, Price: delivery.Price, MiniDelPrice: e.target.value })
                                                }} />
                                        </>
                                        : ""}
                                </div>

                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                    <Accordion.Toggle as={Card.Header} eventKey="0">
                        <span>אופן פעילות</span>
                    </Accordion.Toggle>
                </Card>
                {delivery.Doing ?
                    <Card>
                        <Accordion.Collapse className="collapseparent" eventKey="2">
                            <Card.Body>
                                <div className={"col-md-12 mb-2"}>
                                    <OpeningHours theHours={deliveryHours}
                                        SetTheHours={(hoursBk) => { rest["DeliveryHours"] = hoursBk; setDeliveryHours(hoursBk) }} />

                                    {/* SetTheHours={(hoursBk) => props.updateRest({ ...props.Rest, DeliveryHours: hoursBk })} /> */}
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                        <Accordion.Toggle as={Card.Header} eventKey="2">
                            <span>זמני משלוחים</span>
                        </Accordion.Toggle>
                    </Card> : ""}
            </Accordion>

            {/* "OpeningHours" : */}

            {/* "DeliveryHours" : [  */}


        </>

    );
}

export default TabOrdersOprtions;